import React from "react";
import styled from "styled-components";
import Box from "react-raster";
import { H1, Copy } from "../Typography";
import Container from "../Container";
import Arrow, { ArrowContainer } from "../Arrow";
import ButtonLink from "../ButtonLink";

const FullWidthWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};
`;

const HeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const StyledArrowContainer = styled(ArrowContainer)`
  position: absolute;
  right: 0;
  background-color: white;
`;

function Hero({ backgroundColour, title, description, ctaLabel, ctaUrl }) {
  return (
    <FullWidthWrapper $backgroundColour={backgroundColour}>
      <Container marginBottom="70px" paddingTop={["20px", "40px"]}>
        <Box cols={[6, 10, 10]}>
          <HeroContainer>
            <H1 dangerouslySetInnerHTML={{ __html: title }} />
            {description && <Copy large>{description}</Copy>}
            {ctaUrl && <ButtonLink isWhite label={ctaLabel} url={ctaUrl} />}
            <StyledArrowContainer>
              <Arrow colour="grey" />
            </StyledArrowContainer>
          </HeroContainer>
        </Box>
      </Container>
    </FullWidthWrapper>
  );
}

export default Hero;
